import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.addEventListener("load", function () {
  const el = document.querySelector("#ovensmash-26-pre-overview .slider_overview");
  if (!el) return;

  let thumbsSwiper = null;
  if (window.innerWidth <= 768) {
    const thumbsEl = document.querySelector(
      "#ovensmash-26-pre-overview .slider_overview_thumb"
    );
    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 5,
        spaceBetween: -5,
        loop: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        speed: 400,
        navigation: {
          nextEl: ".overview-thumb-next",
          prevEl: ".overview-thumb-prev",
        },
      });
    }
  }

  const options = {
    slidesPerView: "1",
    centeredSlides: true,
    loop: true,
    spaceBetween: 20,
    effect: thumbsSwiper ? "fade" : "coverflow",
    fadeEffect: { crossFade: true },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false,
    },
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      769: {
        slidesPerView: "auto",
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 612,
          depth: 323,
          modifier: 1,
          slideShadows: true,
        },
      },
    },
    navigation: {
      nextEl: ".overview-next",
      prevEl: ".overview-prev",
    },
  };

  if (thumbsSwiper) {
    options.thumbs = {
      swiper: thumbsSwiper,
    };
    options.allowTouchMove = false;
  }

  const mainSwiper = new Swiper(el, options);

  if (thumbsSwiper) {
    let fromThumb = false;
    // Click next/prev thumb → main đổi theo, thumb strip chạy đẩy active vào giữa (vị trí 3)
    thumbsSwiper.on("slideChange", function () {
      fromThumb = true;
      mainSwiper.slideToLoop(thumbsSwiper.realIndex);
    });
    // Main đổi (swipe/init) → thumb strip chạy đẩy thumb active vào giữa
    mainSwiper.on("slideChange", function () {
      if (!fromThumb) thumbsSwiper.slideToLoop(mainSwiper.realIndex);
      fromThumb = false;
    });
  }
});
